import { render, staticRenderFns } from "./CardVesselDocuments.vue?vue&type=template&id=54289899&"
import script from "./CardVesselDocuments.vue?vue&type=script&lang=js&"
export * from "./CardVesselDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CardVesselDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports